const page = {
  cash: 'cko_credit'
};
export default {
  event: {
    'j-back-btn': [
      {
        type: 'click',
        event: 'click-back-btn'
      }
    ],
    'j-lang-btn': [
      {
        type: 'click',
        event: 'click-lang-btn'
      }
    ],
    'j-lang-item': [
      {
        type: 'click',
        event: 'click-lang-item'
      }
    ],
    'j-popup-close': [
      {
        type: 'click',
        event: 'click-popup-close-btn'
      }
    ],
    'j-payway-item': [
      {
        type: 'click',
        event: 'select_credit'
      }
    ],
    'j-add-payway-item': [
      {
        type: 'click',
        event: 'click-add-payway-item'
      }
    ],
    'j-delete-action': [
      {
        type: 'click',
        event: 'click-delete-action'
      }
    ],
    'j-go-delete': [
      {
        type: 'click',
        event: 'click-go-delete'
      }
    ],
    'j-delete-cancel': [
      {
        type: 'click',
        event: 'click-delete-cancel'
      }
    ],
    'j-pay-btn': [
      {
        type: 'click',
        event: 'submit_credit_pay'
      }
    ],
    'j-add-card-pay-btn': [
      {
        type: 'click',
        event: 'submit_credit_pay'
      }
    ]
  },
  enter: {
    payPage: { event: page.cash }
  },
  router: {
    cash: { event: page.cash }
  }
};
